<template>
  <div>
    <i-panel
      ref="workspaces-modal"
      :visible="showSwitcherModal"
      side="left"
      data-testid="workspace-modal"
      @hide-panel="toggleSwitcherModal"
    >
      <template slot="header">
        <div class="d-flex w-100">
          <div class="w-100">
            <h4 class="i-text-heading-4 i-text-neutral-120 i-mb-2">
              Switch Workspace
            </h4>
            <h5 class="i-text-body-2 i-text-neutral-110 i-mb-0">
              Select a workspace to switch to
            </h5>
          </div>
        </div>
      </template>
      <div
        v-for="item in workspaceItems"
        :key="item.id"
        class="workspaces-list d-flex align-items-center"
      >
        <button
          class="d-flex workspaces-list__item align-items-center"
          :class="{ 'workspaces-list__item--current': item.isCurrentWorkspace }"
          :disabled="item.isCurrentWorkspace"
          @click="switchAction(item.id)"
        >
          <span v-text="item.name"></span>
          <span v-if="item.isCurrentWorkspace" class="label">Current</span>
          <font-awesome-icon v-else class="chevron" icon="chevron-right" />
        </button>
      </div>
      <template v-if="orgAdminAndCreationEnabled" slot="footer">
        <div class="d-flex align-items-center justify-content-center w-100">
          <i-button
            data-testid="create-workspace-button"
            class="w-100"
            text="New Workspace"
            size="lg"
            @button-click="showCreateNewWorkspace()"
          />
        </div>
      </template>
    </i-panel>
    <workspace-creation-modal
      v-if="showCreationModal"
      data-testid="create-workspace-modal"
      @close-create-workspace-modal="closeCreateModal()"
    ></workspace-creation-modal>
    <notifications
      class="workspace-notifications"
      group="workspace"
      position="top right"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { iPanel, iButton } from '@inscribe/signal';
import WorkspaceCreationModal from '@/V2/settings/WorkspaceCreationModal';

export default {
  name: 'WorkspaceSwitcher',
  components: {
    'workspace-creation-modal': WorkspaceCreationModal,
    iPanel,
    iButton,
  },
  props: {
    showText: {
      type: Boolean,
      default: false,
    },
    showSwitcherModal: {
      type: Boolean,
      deafault: false,
    },
    showCreationModal: {
      type: Boolean,
      deafault: false,
    },
  },
  computed: {
    ...mapState(['currentUser', 'workspaces']),

    ...mapGetters({
      orgAdminAndCreationEnabled: 'isOrgAdminAndWorkspacesCreationEnabled',
      workspacesEnabled: 'isWorkspacesEnabled',
    }),
    workspaceItems() {
      return this.workspaces
        .map((org) => {
          return {
            name: org.name,
            id: org.id,
            isCurrentWorkspace: org.name === this.currentUser.organisation.name,
            button: true,
          };
        })
        .sort((a, b) => b.isCurrentWorkspace - a.isCurrentWorkspace);
    },
  },
  methods: {
    ...mapActions(['switchWorkspace']),
    toggleSwitcherModal() {
      this.$emit('toggle-switcher-modal');
    },
    closeCreateModal() {
      this.$emit('set-creation-modal-open', false);
    },
    showCreateNewWorkspace() {
      this.$emit('set-creation-modal-open', true);
    },
    switchAction(orgId) {
      this.switchWorkspace(orgId)
        .then((response) => {
          const { redirect_url } = response.data;
          window.location.href = redirect_url || '/';
        })
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Error switching workspace.',
            duration: 5000,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.nav-item {
  cursor: pointer;
  color: $color-white;

  .nav-text-container {
    margin-top: -2px;

    .nav-item-text {
      font-weight: 500;
      padding-left: 8px;
    }
  }
}

.workspaces-list {
  &__item {
    margin-bottom: 8px;
    border: 1px solid $color-almost-black-60;
    border-radius: 12px;
    color: $color-navy-blue;
    padding: 24px;
    height: 100%;
    background: transparent;
    width: 100%;
    justify-content: space-between;
    outline: 0;

    &--current {
      border-color: #456daa;

      .label {
        background-color: $color-navy-blue-10;
        padding: 4px 6px;
        border-radius: 5px;
        font-size: $font-size-secondary;
        line-height: $font-size-default;
        font-weight: 500;
        color: #485d74;
      }
    }

    .chevron {
      color: $color-almost-black-60;
    }

    &:hover:not([disabled]),
    &:active:not([disabled]),
    &:focus:not([disabled]) {
      background-color: #f5f5f5;
      border-color: $color-almost-black-80;

      .chevron {
        color: $color-almost-black-80;
      }
    }
  }
}

.workspace-notifications {
  margin: 32px;
}
</style>
